import { PatientEncounterSelector } from "./PatientEncounterSelector";
import { CustomerSelector } from "./CustomerSelector";

interface PatientEncounterSectionProps {
  selectedCustomerId: string;
  selectedPatientId: string;
  selectedEncounterId: string;
  onCustomerChange: (customerId: string) => void;
  onPatientChange: (patientId: string) => void;
  onEncounterChange: (encounterId: string) => void;
}

export function PatientEncounterSection({
  selectedCustomerId,
  selectedPatientId,
  selectedEncounterId,
  onCustomerChange,
  onPatientChange,
  onEncounterChange,
}: PatientEncounterSectionProps) {
  return (
    <div className="border-b pb-6">
      <div className="mb-4">
        <CustomerSelector selectedCustomerId={selectedCustomerId} onCustomerChange={onCustomerChange} />
      </div>
      <PatientEncounterSelector
        customerId={selectedCustomerId}
        selectedPatientId={selectedPatientId}
        selectedEncounterId={selectedEncounterId}
        onPatientChange={onPatientChange}
        onEncounterChange={onEncounterChange}
      />
    </div>
  );
}
